import { render, staticRenderFns } from "./ConfirmationFlight.vue?vue&type=template&id=f8f1f4e6&scoped=true&"
import script from "./ConfirmationFlight.vue?vue&type=script&lang=js&"
export * from "./ConfirmationFlight.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationFlight.vue?vue&type=style&index=0&id=f8f1f4e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f1f4e6",
  null
  
)

export default component.exports